import styled from '@emotion/styled';

export const StickyBar = styled.div<{ isActive: boolean; isComposed?: boolean }>(
  ({ theme, isActive, isComposed }) => ({
    margin: `0 calc(${theme.spacing[300]} * -1)`,
    paddingLeft: theme.spacing[300],
    paddingRight: theme.spacing[300],
    paddingBottom: isComposed ? theme.spacing[500] : theme.spacing[400],
    boxShadow: `${isActive ? theme.shadow.subtle : 'none'}`,
    background: theme.color.background.base,
    position: `sticky`,
    top: 0
  })
);

export const ModalContainer = styled.div(`
  // Temporarily set hardcoded minHeight untill we update Freddy to v13 so we can
  // set height 100% on the modal body with sx props
  // Calc: 100% of the viewport - dialog margin top - modal header height - modal body padding

  // fallback for when dvh is not supported
  min-height: calc(100vh - 12.8rem);
  min-height: calc(100dvh - 12.8rem);
`);
